export default {
  theme: {
    'primary-color': '#1d39c4',
  },
  logo: '/favicon.ico', // browser tab logo
  title: 'VaultekSafe IoT Platform', // browser tab title
  layout: {
    title: 'VaultekSafe IoT Platform', // platform title
    logo: '/logo.png', // platform logo
    siderWidth: 208, // left menu width
    headerHeight: 48, // header height
    collapsedWidth: 48,
    mode: 'inline',
    theme: 'light', // 'dark' 'light'
  }
}
